import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { MaterialModule } from '../../app/material.module';
import { DirectivesModule } from '../directives/module';
import { LocationsEdit } from './components/edit/component';
import { LocationsList } from './components/list/component';
import { LocationApiService } from './services/location-api-service';

@NgModule({
  imports: [CommonModule, MaterialModule, DirectivesModule],
  declarations: [LocationsList, LocationsEdit],
  providers: [LocationApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [LocationsEdit],
})
export class LocationModule {}
